/**
 * @module TeamCards
 */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import TeamCard from './TeamCard';

/**
 * Represents the list of team cards for the Careers teams page.
 *
 * @param {object} props - The component props object.
 * @param {Array<Team>} props.teams - Array of team data objects.
 *
 * @returns {React.ReactElement} The TeamCards component.
 */
export default function TeamCards({ teams }) {
  return teams?.length ? (
    <div className="team-cards" data-testid="lc-team-cards">
      {teams.map((team) => (
        <TeamCard key={team.id} team={team} />
      ))}
    </div>
  ) : null;
}
